define('app/event-bus',[],function($) {
  // use this module to trigger and handle global event against
  // e.g. $(eventBus).trigger('some-custom-event', _data)
  // $(eventBus).bind('some-custom-event', function(event, _data) { //do something })
});
